export const DATE_FORMAT = "MMM DD";
export const DATE_TIME_FORMAT = "MMM DD, HH:mm";

export function getInitials(name: string): string {
  const words = name
    .replaceAll("Unknown ", "")
    .split(" ")
    .map((x) => x[0]);

  if (words.length === 1) {
    return words[0];
  }

  return [words[0], words[words.length - 1]].join("");
}
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
